import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "dataForm",
  style: {"min-width":"800px"}
}
const _hoisted_2 = { class: "underlineForm" }
const _hoisted_3 = {
  key: 0,
  class: "dialog-footer mt-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "dataForm",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "100px",
      class: "mb-20"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: "业务名称",
            prop: "businessId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.businessId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.businessId) = $event)),
                placeholder: "输入关键字搜索"
              }, {
                default: _withCtx(() => [
                  (_ctx.businessOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.businessOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "外包公司",
            prop: "outsourceCompanyId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.outsourceCompanyId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.outsourceCompanyId) = $event)),
                placeholder: "输入关键字搜索"
              }, {
                default: _withCtx(() => [
                  (_ctx.outsourceCompanyOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.outsourceCompanyOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "外包公司账户",
            prop: "account"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.ruleForm.account,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.account) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: "",
                "value-key": "alias",
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadOutsourceCompanyAccount()))
              }, {
                default: _withCtx(() => [
                  (_ctx.outsourceCompanyAccountOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.outsourceCompanyAccountOption, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id || index,
                          label: item.alias,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode(" 暂无数据 ", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "总费用",
            prop: "fee"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.ruleForm.fee,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.fee) = $event)),
                type: "input",
                class: "filter-item",
                precision: 2,
                "controls-position": "right",
                onChange: _ctx.handleFeeChange
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "数量",
            prop: "amount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.amount,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.amount) = $event)),
                type: "text",
                class: "filter-item",
                clearable: "",
                disabled: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "单价",
            prop: "unitPrice"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: _ctx.ruleForm.unitPrice,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.unitPrice) = $event)),
                type: "input",
                class: "filter-item",
                precision: 2,
                "controls-position": "right",
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "是否含税",
            prop: "containsRate"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.containsRate,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.containsRate) = $event)),
                onChange: _ctx.handleContainsRateChange,
                placeholder: "输入关键字搜索",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.containsRateOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.containsRateOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          (_ctx.ruleForm.containsRate)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_form_item, {
                  label: "发票类型",
                  prop: "invoiceType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "filter-item",
                      filterable: true,
                      modelValue: _ctx.ruleForm.invoiceType,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleForm.invoiceType) = $event)),
                      placeholder: "输入关键字搜索",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_ctx.invoiceTypeOption.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.invoiceTypeOption, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.mark,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: -1,
                              disabled: ""
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("暂无数据", -1)
                              ]))]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "税率",
                  prop: "rate"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "filter-item",
                      filterable: true,
                      modelValue: _ctx.ruleForm.rate,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.rate) = $event)),
                      placeholder: "输入关键字搜索",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_ctx.rateOption.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.rateOption, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.mark,
                                value: item.rate
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_el_option, {
                              key: 1,
                              value: -1,
                              disabled: ""
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode("暂无数据", -1)
                              ]))]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "mark",
            class: "fullWidth"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.mark,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ruleForm.mark) = $event)),
                type: "textarea",
                class: "filter-item",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    (_ctx.mode !== 'approval')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.submitLoading,
            onClick: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}